import {Component} from '@angular/core';
import {Observable} from "rxjs";
import {Recipe} from "../../dtos/recipe";
import {RecipeService} from "../../recipe-serivce.service";
import {filter, map} from "rxjs/operators";

@Component({
  selector: 'app-recipe-list',
  templateUrl: './recipe-list.component.html',
  styleUrls: ['./recipe-list.component.css']
})
export class RecipeListComponent {

  recipes$: Observable<Recipe[]>;

  constructor(private recipeService: RecipeService) {
    this.recipes$ = recipeService.getRecipes().pipe(
      filter(recipes => recipes != null),
      map(recipes => recipes.sort((a, b) => b.creationDate.seconds - a.creationDate.seconds))
    );
  }

}
